import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  useEffect(() => {
    const s = document.createElement('script')
    s.src = 'https://cdn.iubenda.com/iubenda.js'
    s.async = true
    document.body.appendChild(s)
  }, [])

  return (
    <footer className="bg-neutral-950 border-t border-neutral-900 text-neutral-400">
      {/* Main Footer Links */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16 text-center flex flex-col items-center">
        <div className="space-y-6 flex flex-col items-center w-full">
          {/* Logo */}
          <Link to="/" className="inline-block focus:outline-none">
            <img
              src="https://assets.auxodev.dk/assets/bce4b86c-87d9-405d-a99b-f30b07aaa8a2/logo_1a594eb3.png"
              alt="Casper DJ"
              className="h-12 w-auto object-contain mx-auto"
            />
          </Link>

          {/* Description */}
          <p className="text-xs sm:text-sm text-neutral-400 leading-relaxed max-w-lg mx-auto">
            CasperDJ leverer professionel musik og lyd til firmafester, konfirmationer, storslåede bryllupper og privatfester i hele Danmark.
          </p>

          {/* Badges */}
          <div className="flex items-center justify-center gap-3 pt-1">
            <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-neutral-900 border border-neutral-800 text-xs text-gold-400">
              <i className="fa-solid fa-music text-[10px]" aria-hidden="true" />
              <span>Hele Danmark</span>
            </span>
            <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-neutral-900 border border-neutral-800 text-xs text-neutral-300">
              <i className="fa-solid fa-location-dot text-[10px] text-gold-400" aria-hidden="true" />
              <span>Odense</span>
            </span>
          </div>

          {/* Contact Details */}
          <div className="pt-4 border-t border-neutral-900 w-full max-w-md flex flex-col items-center gap-3 text-xs sm:text-sm">
            <h4 className="text-xs font-bold uppercase tracking-wider text-white">
              Kontakt
            </h4>

            <a
              href="tel:+4530405006"
              className="inline-flex items-center gap-2 text-neutral-200 hover:text-gold-400 transition-colors font-medium"
            >
              <i className="fa-solid fa-phone text-xs text-gold-400" aria-hidden="true" />
              <span>+45 30 40 50 06</span>
            </a>

            <a
              href="mailto:info@casperdj.dk"
              className="inline-flex items-center gap-2 text-neutral-200 hover:text-gold-400 transition-colors font-medium lowercase"
            >
              <i className="fa-solid fa-envelope text-xs text-gold-400" aria-hidden="true" />
              <span>info@casperdj.dk</span>
            </a>

            {/* Social media links */}
            <div className="flex items-center gap-3 pt-2">
              <a
                href="https://www.instagram.com/casperdj.dk/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-8 h-8 rounded-lg bg-neutral-900 border border-neutral-800 hover:border-gold-400/50 hover:bg-gold-400 hover:text-black text-neutral-300 transition-all flex items-center justify-center text-sm"
              >
                <i className="fa-brands fa-instagram" aria-hidden="true" />
              </a>
              <a
                href="https://www.facebook.com/casperdj.dk/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-8 h-8 rounded-lg bg-neutral-900 border border-neutral-800 hover:border-gold-400/50 hover:bg-gold-400 hover:text-black text-neutral-300 transition-all flex items-center justify-center text-sm"
              >
                <i className="fa-brands fa-facebook-f" aria-hidden="true" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCcSTX6_ffrWVlw5hPM5L1EQ"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="w-8 h-8 rounded-lg bg-neutral-900 border border-neutral-800 hover:border-gold-400/50 hover:bg-gold-400 hover:text-black text-neutral-300 transition-all flex items-center justify-center text-sm"
              >
                <i className="fa-brands fa-youtube" aria-hidden="true" />
              </a>
            </div>

            <p className="text-neutral-400 text-xs leading-relaxed mt-1">
              CVR: 37688967<br />
              <span className="text-neutral-500">(Kører ud i hele Danmark)</span>
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 mt-12 border-t border-neutral-900 w-full flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-neutral-500">
          <p>© {currentYear} Casper DJ. Alle rettigheder forbeholdes.</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              href="https://www.iubenda.com/privacy-policy/72930055"
              className="iubenda-white iubenda-noiframe iubenda-embed"
              title="Privatlivspolitik "
            >
              Privatlivspolitik
            </a>
            <span>•</span>
            <a
              href="https://www.iubenda.com/privacy-policy/72930055/cookie-policy"
              className="iubenda-white iubenda-noiframe iubenda-embed"
              title="Cookiepolitik "
            >
              Cookiepolitik
            </a>
            <span className="hidden sm:inline">•</span>
            <p className="text-neutral-500">
              Professionelt DJ udstyr og musik til enhver anledning.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
